import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

export default function backToTop() {
    gsap.registerPlugin(ScrollToPlugin);

    const mybutton = jQuery('#backToTop');

    if (mybutton) {
        jQuery(window).scroll(function() {
            scrollFunction();
        });

        function scrollFunction() {
            if (
                jQuery(document).scrollTop() > 200
            ) {
                jQuery(mybutton).fadeIn();
            } else {
                jQuery(mybutton).fadeOut();
            }
        }

        mybutton.on('click', function () {
            gsap.to(window, {duration: 1, scrollTo: 0});
        });
    }
}
